var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nav-icon",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.99 4.08985C16.73 3.77985 16.3 3.68985 15.92 3.80985C15.11 4.07985 14.19 4.00985 13.39 3.55985C12.59 3.09985 12.07 2.33985 11.89 1.50985C11.8 1.10985 11.5 0.779853 11.1 0.719853C10.1 0.559853 9.06001 0.559853 8.04001 0.729853C7.64001 0.799853 7.35001 1.11985 7.26001 1.51985C7.08001 2.35985 6.57001 3.11985 5.77001 3.58985C4.97001 4.05985 4.05001 4.11985 3.24001 3.85985C2.86001 3.73985 2.43001 3.82985 2.17001 4.13985C1.52001 4.94985 1.01001 5.84985 0.660013 6.79985C0.520013 7.17985 0.660013 7.59985 0.960013 7.85985C1.59001 8.43985 1.99001 9.26985 2.00001 10.1899C2.00001 11.1199 1.60001 11.9399 0.970013 12.5199C0.670013 12.7899 0.540013 13.2099 0.680013 13.5799C0.860013 14.0499 1.08001 14.5199 1.34001 14.9699C1.60001 15.4199 1.90001 15.8399 2.22001 16.2299C2.48001 16.5399 2.91001 16.6299 3.29001 16.5099C4.10001 16.2399 5.02001 16.3099 5.82001 16.7599C6.62001 17.2199 7.14001 17.9799 7.32001 18.8099C7.41001 19.1999 7.70001 19.5299 8.10001 19.5899C9.11001 19.7499 10.14 19.7499 11.16 19.5799C11.56 19.5099 11.85 19.1899 11.94 18.7899C12.12 17.9499 12.63 17.1899 13.43 16.7199C14.23 16.2499 15.15 16.1899 15.96 16.4499C16.35 16.5699 16.78 16.4799 17.03 16.1599C17.68 15.3499 18.19 14.4499 18.55 13.4999C18.69 13.1199 18.55 12.6999 18.25 12.4399C17.61 11.8699 17.21 11.0399 17.2 10.1199C17.2 9.18985 17.6 8.36985 18.23 7.78985C18.53 7.51985 18.66 7.09985 18.52 6.72985C18.34 6.25985 18.12 5.78985 17.86 5.33985C17.61 4.88985 17.31 4.47985 16.99 4.08985Z",
    stroke: "#8295B6",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61001 13.12C11.2448 13.12 12.57 11.7947 12.57 10.16C12.57 8.52519 11.2448 7.19995 9.61001 7.19995C7.97525 7.19995 6.65001 8.52519 6.65001 10.16C6.65001 11.7947 7.97525 13.12 9.61001 13.12Z",
    stroke: "#8295B6",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.8e77c03a6237a4fab3a3d89cca6f7a1a.svg";
export { ForwardRef as ReactComponent };